import { Button } from '@material-tailwind/react'
import React from 'react'

const Servicibility = ({ pinCode, setPinCode, handleCheckPinCode }) => {
  return (
    <div className='rounded-[24px] border border-slate-200 bg-white p-5 shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
        <div className='grid gap-5 lg:grid-cols-[minmax(0,1fr)_220px] lg:items-end'>
          <label className='block'>
            <span className='mb-2 block text-[11px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>Pin code</span>
            <input
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              placeholder='Enter pin code'
              className='h-14 w-full rounded-[18px] border border-slate-200 bg-slate-50 px-4 text-base font-[GilroyMedium] text-slate-900 shadow-[0_8px_20px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-300 focus:border-[#f97316] focus:ring-4 focus:ring-[#f97316]/10'
            />
          </label>
          <Button onClick={handleCheckPinCode} className='h-14 rounded-[18px] bg-[#f97316] px-6 text-sm font-[GilroyBold] text-white shadow-[0_14px_30px_rgba(249,115,22,0.2)] hover:bg-[#ea580c]'>
            Check Serviceability
          </Button>
        </div>
    </div>
  )
}

export default Servicibility
